import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserService } from 'src/app/core/services/user/user.service';

export const UnverifiedOnlyGuard: CanActivateFn = (
  _next: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  const userService = inject(UserService);

  // Use signal-based authentication check (synchronous)
  const hasValidAuth = userService.isAuthenticated();

  if (!hasValidAuth) {
    return true; // Allow access to auth routes
  }

  return router.createUrlTree(['/']); // Redirect authenticated users
};
